import request from '../request'

// 获取消息通知列表
export function getMessageList(params) {
  return request({
    url: '/app/message/list',
    method: 'get',
    params: {
      page: 1,
      pageSize: 20,
      ...params
    },
  })
}

// 标记消息为已读
export function readMessage(params) {
  return request({
    url: '/app/message/read',
    method: 'get',
    params,
  })
}
